import { LiquiditySource } from '@src/enums'

export const isPotentiallyCCTP = (
    sellToken: string | undefined,
    buyToken: string | undefined,
    sellNetworkId: number | string,
    buyNetworkId: number | string,
    liquiditySource?: LiquiditySource
): boolean => {
    // A real CCTP transfer requires:
    // 1. Both tokens are USDC
    // 2. They're on different chains
    // 3. The liquiditySource is specifically cctpDirect

    const tokensMatch = sellToken === 'USDC' && buyToken === 'USDC'
    const differentChains = sellNetworkId !== buyNetworkId
    const isCctpSource = liquiditySource === LiquiditySource.cctpDirect

    // If liquiditySource is provided, use it to determine if this is definitely CCTP
    if (liquiditySource !== undefined) {
        return tokensMatch && differentChains && isCctpSource
    }

    // If no liquiditySource is provided, we can only make a guess based on tokens and chains
    // (this is the legacy behavior, better to provide liquiditySource when possible)
    return tokensMatch && differentChains
}
